<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import LandingPage from '@/views/LandingPage'

export default {
  name: 'Language',
  components: {
    DashboardPage: () => import('@/views/DashboardPage'),
    LandingPage,
  },
  computed: {
    ...mapState('auth', { activeUser: 'status' }),
    ...mapState('auth', ['settings']),
    bodyClass() {
      return this.$route.meta.body && this.$route.meta.body[this.landingOption ? 'landing' : 'dashboard']
    },
    landingOption() {
      return Boolean(this.settings && this.settings.pages && this.settings.pages.landing && !this.activeUser)
    },
    view() {
      return this.landingOption ? 'LandingPage' : 'DashboardPage'
    },
  },
  mounted() {
    const classes = this.bodyClass ? this.bodyClass.split(' ') : []
    classes.forEach(classname => {
      document.body.classList.add(classname)
    })
  },
}
</script>
